export const CONSULTAR_MENSAGEM_PROTOCOLO_SENHA = 'CONSULTAR_MENSAGEM_PROTOCOLO_SENHA';
export const ENVIAR_AUTENTICACAO_MENSAGEM_PROTOCOLO_SENHA = 'ENVIAR_AUTENTICACAO_MENSAGEM_PROTOCOLO_SENHA';
export const VALIDAR_CODIGO = 'VALIDAR_CODIGO';
export const CADASTRAR_MENSAGEM = 'CADASTRAR_MENSAGEM';
export const ARMAZENA_PROTOCOLO = 'ARMAZENA_PROTOCOLO';
export const ARMAZENA_NAVEGACAO = 'ARMAZENA_NAVEGACAO';
export const ALERTA = 'ALERTA';
export const LISTAR_CLASSIFICACAO = 'LISTAR_CLASSIFICACAO';
export const LISTAR_TIPO_PESSOA_VISIVEL = 'LISTAR_TIPO_PESSOA_VISIVEL';
export const LISTAR_UF = 'LISTAR_UF';
export const CONSULTAR_CEP = 'CONSULTAR_CEP';
export const CONSULTA_SAS = 'CONSULTA_SAS';
export const OBTER_GRUPOTRATAMENTO_UF_CLASSIFICACOES = 'OBTER_GRUPOTRATAMENTO_UF_CLASSIFICACOES';
export const LISTAR_CONHECIMENTO_DENUNCIA = 'LISTAR_CONHECIMENTO_DENUNCIA';
export const TRAMITAR_MENSAGEM = 'TRAMITAR_MENSAGEM';
export const PESQUISAR_ANEXOS = 'PESQUISAR_ANEXOS';
export const ANEXAR = 'ANEXAR';
export const GRAVAR_CAMPANHA = 'GRAVAR_CAMPANHA'
export const OBTER_CAMPANHA_POR_TOKEN = 'OBTER_CAMPANHA_POR_TOKEN'
export const OBTER_CAMPANHA_POR_IDCAMPANHA = 'OBTER_CAMPANHA_POR_IDCAMPANHA'
export const ENVIAR_PROTOCOLOS_CIDADAO = 'ENVIAR_PROTOCOLOS_CIDADAO';

export const RELAT_ASSUNTO_POR_NATUREZA_ESTRUTURA = 'RELAT_ASSUNTO_POR_NATUREZA_ESTRUTURA';
export const RELAT_CLASSIFICACAO_ESTRUTURA_POR_ASSUNTO = 'RELAT_CLASSIFICACAO_ESTRUTURA_POR_ASSUNTO';
export const RELAT_CLASSIFICACAO_ESTRUTURA = 'RELAT_CLASSIFICACAO_ESTRUTURA';
export const RELAT_DIRECIONAMENTO_GRUPOTRATAMENTO = 'RELAT_DIRECIONAMENTO_GRUPOTRATAMENTO';
export const RELAT_HIERARQUIA_ASSUNTO_POR_NATUREZA = 'RELAT_HIERARQUIA_ASSUNTO_POR_NATUREZA';
export const RELAT_HIERARQUIA_ASSUNTO = 'RELAT_HIERARQUIA_ASSUNTO';
export const RELAT_HIERARQUIA_ESTRUTURA = 'RELAT_HIERARQUIA_ESTRUTURA';
export const RELAT_INDICADOR_NIVEL_CLASSIFICACAO = 'RELAT_INDICADOR_NIVEL_CLASSIFICACAO';
export const RELAT_INDICADOR_TEMPO_RESPOSTA_FAIXA = 'RELAT_INDICADOR_TEMPO_RESPOSTA_FAIXA';
export const RELAT_PARAMETROS_PESQUISA = 'RELAT_PARAMETROS_PESQUISA';
export const RELAT_TEMPO_RESPOSTA_CLASSIFICACAO_FAIXA = 'RELAT_TEMPO_RESPOSTA_CLASSIFICACAO_FAIXA';
export const RELAT_TEMPO_RESPOSTA_FAIXA = 'RELAT_TEMPO_RESPOSTA_FAIXA';
export const RELAT_TOP5_ASSUNTO = 'RELAT_TOP5_ASSUNTO';




/** WEBPACK FOOTER **
 ** ./src/components/actions/actionTypes.js
 **/